import { combineSlices } from "@reduxjs/toolkit";
import { editModeSlice } from "./editModeSlice";

export const uiSlice = combineSlices({
  editMode: editModeSlice.reducer
})